var isPure = false;

export { isPure as default };
